import Component from 'can/component/component';
import template from './live-video-right-rail-clips.stache';
import can from 'can';
import FeedService from 'scripts/services/base-feed-service';
import _ from 'lodash';
import PlayerService from 'scripts/services/player-service';

const clipsUrl = window.globalSettings.feeds.videos.playerRecapsUrl;

export const YOUR_CLIPS_KEY = 'your_clips_watched';

export function filterWatchedVideos(videos) {
    const watchedVideosIds = localStorage.getItem(YOUR_CLIPS_KEY);

    if (!watchedVideosIds || !watchedVideosIds.length) {
        return videos;
    }

    return videos.filter((it) => {
        return !watchedVideosIds.includes(it.video.identifier);
    });
}

export function mapVideosForPlayer(viewModel) {
    const videos = viewModel.attr('data.videos');
    const player = viewModel.attr('data.player');

    return videos.map((it) => ({
        id: it.video.identifier,
        title: `${player.firstName} ${player.lastName}`,
        header: 'Favorite Player',
        roundNumber: it.roundNumber,
        holeNumber: it.holeNumber,
    }));
}

Component.extend({
    tag: 'video-right-rail-clips',
    template: template,
    leakScope: false,
    viewModel: {
        initLoad: true,
        define: {
            cards: {
                Type: can.List,
                Value: can.List,
            },
            activeChannels: {
                Type: can.List,
                Value: can.List,
            },
            activeView: {
                type: 'object',
                value: null,
            },
            player: {
                type: 'object',
            },
            favToggled: {
                type: 'number',
            },
            data: {
                type: 'object',
            },
            adSizes: {
                Type: can.Map,
                get() {
                    return {
                        width: 300,
                        height: 150,
                    };
                },
            },
            products: {
                Type: can.Map,
                Value: null,
            },
            productsCtaLink: {
                Type: can.Map,
                Value: null,
            },
            highlightEnded: {
                type: 'number',
            },
            noFavPlayers: {
                type: 'boolean',
            },
        },
        goToLeaderboard() {
            this.dispatch({ type: 'tabChange', payload: 'leaderboard' });
        },
    },
    events: {
        inserted() {
            new FeedService({
                feedUrl: clipsUrl,
                fromUpdate: false,
                autoUpdate: true,
            })
                .on('data', (type, data) => {
                    let cards = data.playersRecaps || [];
                    this.viewModel.attr('data', data);
                    let refresh = this.compareCards(cards);
                    if (refresh) {
                        this.updateCards(cards);
                    }

                    this.viewModel.dispatch('dataLoaded');
                })
                .on('error', (error) => {
                    console.error('Error fetching live channels', error);
                })
                .fetch();

            this.viewModel.bind('highlightEnded', () => {
                this.updateCards(this.viewModel.attr('cards').serialize());
            });

            this.viewModel.bind('favToggled', () => {
                const recaps = this.viewModel.attr('data.playersRecaps');

                this.updateCards(
                    recaps && recaps.serialize ? recaps.serialize() : [],
                );
            });
        },
        compareCards: function(newCards) {
            return this.cardsToCompare && this.cardsToCompare.length
                ? !_.isEqual(this.cardsToCompare, newCards)
                : true;
        },
        updateCards: function(cards) {
            const filteredCards = cards
                .filter((card) =>
                    PlayerService.isInFavorites(card.player.identifier),
                )
                .map((card) => {
                    const videos = _.flatten(
                        card.rounds.map((round) =>
                            filterWatchedVideos(round.videos).map((video) =>
                                Object.assign({}, video, {
                                    roundNumber: round.roundNumber,
                                }),
                            ),
                        ),
                    );

                    if (!videos.length) {
                        return;
                    }

                    return Object.assign(card, { videos });
                })
                .filter(Boolean);

            this.cardsToCompare = _.cloneDeep(filteredCards);
            let initLoad = this.viewModel.attr('initLoad');

            this.viewModel.attr('cards', filteredCards);
            this.viewModel.attr(
                'noFavPlayers',
                !PlayerService.getFavorites().length,
            );

            if (initLoad) {
                this.viewModel.attr('initLoad', false);
            }
        },

        'right-rail-clip click'(element) {
            const videos = mapVideosForPlayer(element.viewModel());

            this.viewModel.player.setHighlightInPiP(
                {
                    videos,
                },
                0,
            );

            if (
                document
                    .querySelectorAll('.video-js')[1]
                    .querySelector('.player-slate')
            ) {
                this.viewModel.player.removeSlateOverrideToMainPiP();
            }
        },
    },
});
